import { Component, OnInit, ViewEncapsulation, Input, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormBuilder } from '@angular/forms';
import { GlobalService } from '../service/global.service';
import { environment } from 'src/environments/environment';
import { ProjectSummaryInfo } from '../model/ProjectSummaryInfo';
import { LookupInfo } from '../model/lookup.model';
import { TokenService } from '../service/token.service';

@Component({
  selector: 'app-dashboard',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  /******************************* Variables ********************************/
  @Input() ProjectCode: string;
  baseurl: string;

  _EmpCode: string = "";
  CountProjectSummary: number = 0;
  ListProjectSummary: ProjectSummaryInfo[] = [];
  ListLookupProjectType: LookupInfo[] = [];
  ListMonth: any = [];
  ListYear: number[] = [];
  CurrentYear: number;

  ddlProjectType: string = "";
  ddlMonth: string = "";
  ddlYear: string = "";


  isSearchSubmitted: boolean = false;


  RoleCode: any
  /******************************* Variables ********************************/


  /******************************* Functions ********************************/
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService)
  {
    this.baseurl = environment.base_api;
    this.RoleCode = localStorage.getItem("EmpRoleCode");
    GlobalService.CheckPagingAccessRights();
  }

  ngOnInit() {
    this._EmpCode = localStorage.getItem("EmpCode");
    this.LoadLookupProjectType();
    this.LoadListProjectSummary();

    var d = new Date()
    this.CurrentYear = d.getFullYear();
    this.ListMonth = [
      "January", "February", "March",
      "April", "May", "June", "July",
      "August", "September", "October",
      "November", "December"
    ];
    for (var i = (this.CurrentYear - 50); i <= (this.CurrentYear + 100); i++) {
      this.ListYear.push(i);
    }
    
  }


  async LoadListProjectSummary() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      if (this.RoleCode != "DIRECTOR" && this.RoleCode != "SALEDIRECTOR" && this.RoleCode != "PROJDIRECTOR") objectjson["EmpCode"] = this._EmpCode;

      if (this.RoleCode == "MANAGER" || this.RoleCode == "HRMANAGER" || this.RoleCode == "PROJECTCO") objectjson["RoleCode"] = this.RoleCode;

      if (!!this.ddlProjectType) {
        objectjson["ProjectType"] = this.ddlProjectType;
      }
      if (!!this.ddlMonth) {
        objectjson["ProjectMonthSch"] = this.ddlMonth;
      }
      if (!!this.ddlYear) {
        objectjson["ProjectYearSch"] = this.ddlYear;
      }

      let strjson = JSON.stringify(objectjson);
      console.log(strjson);


      this.httpClient
        .post<ProjectSummaryInfo[]>(this.baseurl + "Project/GetProjectSummary",
          strjson, httpOptions)
        .toPromise().then(data => {
          this.CountProjectSummary = data.length;
          this.ListProjectSummary = data;
        });
    }
  }
  async LoadLookupProjectType() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson["LookupType"] = "PROJECTSTATUS";

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup",
          strjson, httpOptions)
        .toPromise().then(data => {
          if (data.length > 0) {
            this.ListLookupProjectType = data;
          }
        });
    }
  }

  OnDdlProjectTypeChange()
  {
    this.isSearchSubmitted = true;
    this.LoadListProjectSummary();
  }

  OnDdlMonthChange() {
    this.isSearchSubmitted = true;
    this.LoadListProjectSummary();
  }
  OnDdlYearChange() {
    this.isSearchSubmitted = true;
    this.LoadListProjectSummary();
  }
}
